'use client';

import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from '@common/components';
import { formatOptionLabel } from '../../../../_utils/formatOptionLabel';
interface OptionItem {
  optionItemId: number;
  optionItemName: string;
  extraPrice: number;
  isSoldOut: boolean;
}
interface OptionDropdownProps {
  groupName: string;
  options: OptionItem[];
  selectedOptionItemId?: number;
  requiredYN?: boolean;
  onSelect: (option: OptionItem) => void;
}
export const OptionDropdown = t0 => {
  const $ = _c(20);
  const {
    groupName,
    options,
    selectedOptionItemId,
    requiredYN,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== requiredYN) {
    t1 = requiredYN && <span className="font-600 text-R-500">*</span>;
    $[0] = requiredYN;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== groupName || $[3] !== t1) {
    t2 = <h3 className="flex items-center gap-4 font-600 text-Gray-900 typo-body3">{groupName}{t1}</h3>;
    $[2] = groupName;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== options) {
    t3 = options.map(_temp);
    $[5] = options;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onSelect || $[8] !== options) {
    t4 = optionItemId => {
      const option_0 = options.find(opt => opt.optionItemId === optionItemId);
      if (option_0 && !option_0.isSoldOut) {
        onSelect(option_0);
      }
    };
    $[7] = onSelect;
    $[8] = options;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== options) {
    t5 = item => {
      const option_1 = options.find(opt_0 => opt_0.optionItemId === item.value);
      return option_1?.isSoldOut ?? false;
    };
    $[10] = options;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== selectedOptionItemId || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <DropdownMenu dimensions="H48" options={t3} placeholder={"\uC0C1\uD488 \uC635\uC158\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694."} value={selectedOptionItemId} onChange={t4} itemDisabled={t5} className="w-full" />;
    $[12] = selectedOptionItemId;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t2 || $[18] !== t6) {
    t7 = <div className="flex flex-col gap-8">{t2}{t6}</div>;
    $[17] = t2;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
function _temp(option) {
  return {
    label: formatOptionLabel(option.optionItemName, {
      isSoldOut: option.isSoldOut,
      extraPrice: option.extraPrice
    }),
    value: option.optionItemId
  };
}